import React from 'react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'http://impulsodigital.vip/cart/44844060049494:1';
const VALUE_ROWS = [{
  label: 'Sistema Microcemento™ completo',
  price: '$55.000'
}, {
  label: '6 Bonus exclusivos',
  price: '$54.000'
}, {
  label: 'Mega Bonus: Muebles de Microcemento',
  price: '$50.000'
}];
export function FinalOffer() {
  return <section className="py-16 md:py-24 px-4 bg-black border-t border-white/5" data-id="element-79">
      <div className="max-w-2xl mx-auto" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-81">
          <p className="text-brand-yellow font-bold text-sm md:text-base uppercase tracking-[0.2em] mb-5" data-id="element-82">
            Tu momento es ahora
          </p>
          <h2 className="text-4xl sm:text-5xl md:text-6xl text-white leading-[1.02] mb-6 break-words" data-id="element-83">
            CADA SEMANA QUE PASA,{' '}
            <span className="text-brand-yellow" data-id="element-84">
              ALGUIEN MÁS COBRÓ ESE TRABAJO.
            </span>
          </h2>
          <p className="text-lg md:text-xl text-gray-400 font-medium max-w-xl mx-auto leading-relaxed" data-id="element-85">
            El mercado del microcemento no espera. La pregunta es si vas a
            cobrar con el cambio, o quedarte mirando.
          </p>
        </motion.div>

        {/* Value table card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-gray border border-white/10 rounded-3xl p-6 md:p-8 mb-6" data-id="element-86">
          <div className="space-y-5" data-id="element-87">
            {VALUE_ROWS.map((row, i) => <div key={i} className="flex items-center justify-between gap-4" data-id="element-88">
                <span className="text-base md:text-lg text-gray-200 font-medium" data-id="element-89">
                  {row.label}
                </span>
                <span className="text-base md:text-lg text-gray-500 line-through font-bold shrink-0" data-id="element-90">
                  {row.price}
                </span>
              </div>)}
          </div>

          <div className="border-t border-white/10 my-6" data-id="element-91" />

          <div className="flex items-center justify-between gap-4" data-id="element-92">
            <span className="text-sm md:text-base text-gray-400 font-bold uppercase tracking-wider" data-id="element-93">
              Valor total real
            </span>
            <span className="text-3xl md:text-4xl text-brand-yellow font-display text-glow shrink-0" data-id="element-94">
              $160.000
            </span>
          </div>
        </motion.div>

        {/* Price card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-black border-2 border-brand-yellow rounded-3xl p-6 md:p-8 mb-8 box-glow flex items-center justify-between gap-4" data-id="element-95">
          <span className="text-base md:text-xl text-white font-bold uppercase tracking-wide" data-id="element-96">
            Tu inversión hoy
          </span>
          <span className="text-4xl md:text-5xl text-brand-yellow font-display text-glow shrink-0" data-id="element-97">
            $19.999
          </span>
        </motion.div>

        {/* Final CTA */}
        <motion.a href={CHECKOUT_URL} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="block w-full text-center bg-brand-yellow hover:bg-brand-yellowHover text-black font-display uppercase tracking-wide text-lg sm:text-xl md:text-2xl py-6 px-6 rounded-2xl leading-tight shadow-[0_0_40px_rgba(255,193,7,0.45)] hover:shadow-[0_0_55px_rgba(255,193,7,0.65)] transition-all duration-300" data-id="element-98">
          → Sí, quiero acceder al sistema completo
        </motion.a>
      </div>
    </section>;
}